import * as stylex from '@stylexjs/stylex';
import { headerStyles as styles } from '@/header/header.styles';
import { faChevronDown } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon, TriggerWithDropdown } from '@seeqdev/qomponents';
import type { DropdownItems } from '@seeqdev/qomponents';

/** Shows workbook actions and submenus in the shared dropdown. */
export const WorkbookActionsMenu = ({
  items,
  accessibleName,
  isPending = false,
  setFocusOnTriggerOnClose = true,
}: {
  items: DropdownItems[];
  accessibleName: string;
  isPending?: boolean;
  setFocusOnTriggerOnClose?: boolean;
}) => (
  <span {...stylex.props(styles.workbookMenuFocus)}>
    <TriggerWithDropdown
      triggerIcon={
        <>
          <span {...stylex.props(styles.accessibleName)}>{accessibleName}</span>
          <Icon icon={faChevronDown} type="inherit" />
        </>
      }
      align="start"
      alignOffset={0}
      xstyle={styles.actionTrigger}
      aria-busy={isPending}
      setFocusOnTriggerOnClose={setFocusOnTriggerOnClose}
      dropdownItems={items}
    />
  </span>
);
